export const licensedWidgetUpdateManifest = {
  vendorBuildLabel: '5.19.2',
  upstreamPackageVersion: '5.19.2',
  widgetPackage: {
    name: '@dx-private/dxchart5-react-widget',
    version: '5.19.2',
    main: './dist/widget.ts',
    dxchartsLiteVersion: '2.7.32',
    artifactCount: 35,
    treeSha256: '7812f1708629e0d2a4b6cbd244bcf6e46ff9ad011c8c70c62c081e17810a604b',
    packageJsonSha256: '7347753b697409fd1a79a366419a1ea18d145a5ed6f46a98143fe62802fe6a40',
    distIndexJsSha256: '7728229ad61592d93e2b0789babb999cd2ab53463dd2f2c295ea563d27e1a35e',
    distIndexDtsSha256: '6ca1f8521ec2a14ba3b408b8c74e2def87284c0a47cb0558fe5b2e49e7f6d7d1',
    widgetConfigDtsSha256: '64ec92c2afa4778d4c4cb31352851f2ea1a174763318bf25bd2fc091cbbbc901',
    widgetDtsSha256: '117d668624b51e1a31407431e4823f8117f0b2dc6753c2eec8681f02b5bbc4dd',
  },
  mockProvidersPackage: {
    name: '@dx-private/dxchart5-react-mock-providers',
    version: '1.0.3',
    dxchartsLiteVersion: '2.7.32',
    artifactCount: 36,
    treeSha256: '04ec287ddb757cb8784c723310594a7cafb4c36286ae83624f2a0caebce9d126',
    packageJsonSha256: '51578b30cfe3ada12c2903821a458d31a70c1ed75871f363a78046d4dea646a5',
  },
  dxstudiesPackage: {
    name: '@dx-private/dxstudies',
    version: '66.0.1759419544892',
    artifactCount: 4,
    treeSha256: '2a3456a991d3fdc5596cd229e5add44959714b868db6b4070b50a467f77dd48e',
    packageJsonSha256: 'fb0ab6cb34e299f4c27b2c938e2eb80f037b222ef02b736bb4bd39d89320d171',
    runtimeSha256: '0119d61f4e36b19e876f9fe5a0ce12f1d1c58d2d226db00361b261142a9fc6eb',
  },
  runtimeAssets: {
    publicPath: '/vendor/dxchart5-react-widget/dist',
    artifactCount: 31,
    treeSha256: 'b035d5be3fc46a8236fd8e7535f21622e4293fc4ac6754378487784b5cd8b871',
    indexJsSha256: '7728229ad61592d93e2b0789babb999cd2ab53463dd2f2c295ea563d27e1a35e',
  },
  rollbackTarget:
    'Restore both ../dxchart.lib/* staged snapshots and public/vendor/dxchart5-react-widget/dist/* from the same known-good vendor drop.',
} as const

export type LicensedWidgetUpdateManifest = typeof licensedWidgetUpdateManifest
